import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TertiaryTopRoundButton from "../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import TopBarButtons from "../../../components/_utils/CommonButtons/TopBarButton";
import CommonCardDashboard from "../../../components/_utils/CommonCardDashboard";
import QuickActionCard from "../../../components/QuickActionCard/QuickActionCard";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { getAllPrivateTransactions } from "../../../redux/features/privatetransactions/privatetransactions";
import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const PrivateDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    allPrivateTransactionsData,
    allPrivateTransactionsLoading,
    allPrivateTransactionsError,
  } = useSelector((state) => state.privatetransactions);

  const services = useSelector((state) => state.refreshToken.services) ?? [];
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const totalCount =
    allPrivateTransactionsData?.total_count ??
    GlobalConfiguration?.lengthCheckZero;

  const isViewAllDisabled =
    allPrivateTransactionsLoading ||
    totalCount === GlobalConfiguration?.lengthCheckZero;

  const onMount = () => {
    dispatch(getAllPrivateTransactions({ data: {} }));
  };

  useEffect(() => {
    dispatch(enableSwitcher());

    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [dispatch]);

  useEffect(() => {
    onMount();
  }, [markerData]);

  return (
    <div className="h-screen bg-primary-bg flex flex-col ">
      <div className="Qsmd:h-navbar-breadcrumb-height"></div>
      <div className="pt-padding-md Qlg:w-max-content-width w-full mx-auto Qlg:px-padding-base px-padding-md">
        <div className="w-width-full p-padding-sm fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center z-z-index-tooltip Qlg:hidden rounded-bl-border-radius-sm rounded-br-border-radius-sm">
          <div className="flex flex-row items-center">
            <img
              src={ICONS?.PRIVATE_TRANSACTION_BLUE_CIRCLE}
              alt="Xpentra Logo"
              className="h-icon-lg w-icon-lg mr-margin-sm"
            />
            <div className="flex flex-col">
              <div className="flex items-center">
                <p className="text-primary-bg font-semibold text-font-md">
                  Private
                </p>
              </div>
              <p className="text-primary-bg text-font-xs">Transactions</p>
            </div>
          </div>
        </div>
        <div className="flex Qsmd:flex-row flex-col  gap-gap-md Qlg:px-padding-sm Qsmd:mt-margin-base  mt-[var(--stepper-gap-between)]">
          {/* Left side  */}
          <div className="flex flex-col Qsmd:w-dashboard-left-card-width w-full ">
            <div
              className={`w-full flex items-center justify-center ${!services?.includes("CPrivateTransaction") ? "cursor-not-allowed" : ""}`}
              onClick={() => {
                if (!services?.includes("CPrivateTransaction")) {
                  navigate("/feature_not_assigned", {
                    replace: true,
                    state: {
                      unavailableService: "CPrivateTransaction",
                    },
                  });
                }
              }}
            >
              <TopBarButtons
                services={services}
                items={[
                  {
                    imgColor: "var(--text-primary)",
                    icon: ICONS?.ADD_BUTTON,
                    label: <>Create private transaction</>,
                    requiredservice: ["CPrivateTransaction"],
                    path: "/private_transaction_dashboard/create_private_transaction",
                  },
                ]}
              />
            </div>
            <div className="w-width-full lg:mt-margin-md md:mt-margin-md sm:mt-margin-md mt-margin-md rounded-border-radius-md relative overflow-hidden">
              <h2 className="bg-primary-card flex items-center justify-between pl-padding-md transition-all duration-animation-medium">
                <div className="flex items-center gap-gap-sm">
                  <img
                    src={ICONS?.APPROVAL_STATUS}
                    alt="transaction header"
                    className="w-icon-sm"
                  />
                  <p className="text-font-sm font-semibold font-sans text-text-secondary">
                    Statuses
                  </p>
                </div>

                <div className="flex">
                  <div className="border-dividing"></div>
                  <TertiaryTopRoundButton
                    btnText="View all"
                    icon={ICONS?.ARROW_RIGHT_WHITE}
                    imgColor="var(--text-primary)"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      if (isViewAllDisabled) return;
                      navigate(
                        "/private_transaction_dashboard/private_transaction_view_all",
                      );
                    }}
                    isDisabled={isViewAllDisabled}
                    enabledTextColor={"var(--text-primary)"}
                    disabledTextColor={"var(--text-secondary)"}
                    enabledBgColor={"var(--primary-card)"}
                    disabledBgColor={"var(--primary-card)"}
                  />
                </div>
              </h2>
              <div>
                <div className="flex flex-col Qsmd:flex-row gap-gap-base p-padding-base bg-primary-nav">
                  <CommonCardDashboard
                    label="Require validations"
                    count={
                      services?.includes("Admin") ||
                      services?.includes("ValidatorPrivateTransaction")
                        ? (allPrivateTransactionsData?.summary
                            ?.transaction_summary?.created_transaction_count ??
                          "00")
                        : "N/A"
                    }
                    color="var(--pending)"
                    loader={allPrivateTransactionsLoading}
                    onClick={() =>
                      navigate(
                        "/private_transaction_dashboard/require_validation",
                      )
                    }
                    onServiceUnavailable={() =>
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "ValidatorPrivateTransaction",
                        },
                      })
                    }
                  />
                  <div className="border-r-border border-primary-bg Qsmd:my-margin-md my-margin-base "></div>
                  <CommonCardDashboard
                    label="Require approvals"
                    count={
                      services?.includes("Admin") ||
                      services?.includes("APrivateTransaction")
                        ? (allPrivateTransactionsData?.summary
                            ?.transaction_summary
                            ?.actionable_transaction_count ?? "00")
                        : "N/A"
                    }
                    color="var(--pending)"
                    loader={allPrivateTransactionsLoading}
                    onClick={() =>
                      navigate(
                        "/private_transaction_dashboard/private_transaction_approval",
                      )
                    }
                    onServiceUnavailable={() =>
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "APrivateTransaction" },
                      })
                    }
                  />
                  <div className="border-r-border border-primary-bg Qsmd:my-margin-md my-margin-base "></div>

                  <CommonCardDashboard
                    label="Require authentications"
                    count={
                      services?.includes("Admin") ||
                      services?.includes("OTPPrivateTransaction")
                        ? (allPrivateTransactionsData?.summary
                            ?.transaction_summary
                            ?.pending_for_otp_transaction_count || 0) +
                          (allPrivateTransactionsData?.summary
                            ?.transaction_summary
                            ?.otp_requested_transaction_count || 0) +
                          (allPrivateTransactionsData?.summary
                            ?.transaction_summary
                            ?.otp_submitted_transaction_count || 0)
                        : "N/A"
                    }
                    color="var(--pending)"
                    loader={allPrivateTransactionsLoading}
                    onClick={() =>
                      navigate(
                        "/private_transaction_dashboard/authentication_file",
                      )
                    }
                    onServiceUnavailable={() =>
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "OTPPrivateTransaction",
                        },
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Left side  */}

          {/* Right side  */}
          <div className="Qsmd:w-dashboard-right-card-width w-full">
            <QuickActionCard
              title="More actions"
              labels="MIS report"
              onClick={() => {
                if (services?.includes("SMisUser")) {
                  navigate(
                    "/private_transaction_dashboard/generate_mis_report",
                  );
                } else {
                  navigate("/feature_not_assigned", {
                    state: { unavailableService: "SMisUser" },
                  });
                }
              }}
              labelDisabled={!services?.includes("SMisUser")}
              type={"privateTxn"}
            />
          </div>
          {/* Right side  */}
        </div>
      </div>
    </div>

    //   My code
  );
};

export default PrivateDashboard;
